import { CollaboratorRequest } from '../../models/collaborator/collaborator-request.model';
import { CollaboratorResponse } from '../../models/collaborator/collaborator-response.model';
import { Paged } from '../../models/paged.model';
import { ValuesPurchaseRequest } from '../../models/purchase/values-purchase-request.model';
import {
    COLLABORATOR_LIST,
    COLLABORATOR_LIST_ERROR,
    COLLABORATOR_LIST_SUCCESS,
    COLLABORATOR_LIST_VALUES,
    COLLABORATOR_LIST_VALUES_ERROR,
    COLLABORATOR_LIST_VALUES_SUCCESS,
    EDIT_COLLABORATOR_VALUE,
    EDIT_COLLABORATOR_VALUE_ERROR,
    EDIT_COLLABORATOR_VALUE_SUCCESS,
    RESET_PURCHASE_COLLABORATOR,
    RESET_PURCHASE_COLLABORATOR_ERROR,
    RESET_PURCHASE_COLLABORATOR_SUCCESS,
    SUMMARY_OLD_VALUE_REBALANCE
} from '../contants';

export const resetPurchaseCollaborator = () => ({
  type: RESET_PURCHASE_COLLABORATOR,
  payload: null,
});

export const resetPurchaseCollaboratorSuccess = () => ({
  type: RESET_PURCHASE_COLLABORATOR_SUCCESS,
  payload: null,
});

export const resetPurchaseCollaboratorError = (message: any) => ({
  type: RESET_PURCHASE_COLLABORATOR_ERROR,
  payload: { message },
});

export const getCollaborators = (assignorGuid: string, managerGuid: string, limit: number, page: number, collaboratorRequest: CollaboratorRequest, groupId?: number) => ({
  type: COLLABORATOR_LIST,
  payload: { assignorGuid, managerGuid, limit, page, collaboratorRequest, groupId },
});

export const getCollaboratorsSuccess = (response: Paged<CollaboratorResponse>) => ({
  type: COLLABORATOR_LIST_SUCCESS,
  payload: response,
});

export const getCollaboratorsError = (message: any) => ({
  type: COLLABORATOR_LIST_ERROR,
  payload: { message },
});

export const getCollaboratorsValues = (assignorGuid: string, managerGuid: string, limit: number, page: number, productId: number, purchaseId: number) => ({
  type: COLLABORATOR_LIST_VALUES,
  payload: { assignorGuid, managerGuid, limit, page, productId, purchaseId },
});

export const getCollaboratorsValuesSuccess = (collaboratorValues: Paged<CollaboratorResponse>, oldValue: number) => ({
  type: COLLABORATOR_LIST_VALUES_SUCCESS,
  payload: { collaboratorValues, oldValue },
});

export const getCollaboratorsValuesError = (message: any) => ({
  type: COLLABORATOR_LIST_VALUES_ERROR,
  payload: { message },
});

export const editCollaboratorValue = (productId: number, collaboratorId: number, providedValue: number) => ({
  type: EDIT_COLLABORATOR_VALUE,
  payload: { productId, collaboratorId, providedValue },
});

export const editCollaboratorValueSuccess = (collaborators: Paged<CollaboratorResponse>, editedCollaborators?: ValuesPurchaseRequest) => ({
  type: EDIT_COLLABORATOR_VALUE_SUCCESS,
  payload: { collaborators, editedCollaborators },
});

export const editCollaboratorValueError = (message: any) => ({
  type: EDIT_COLLABORATOR_VALUE_ERROR,
  payload: { message },
});

export const summaryOldValueRebalance = (newOldValue: number) => ({
  type: SUMMARY_OLD_VALUE_REBALANCE,
  payload: { newOldValue },
});
